export enum SmartInstallmentStatus {
  ON_SCHEDULE = 'on_schedule',
  OFF_SCHEDULE = 'off_schedule',
  CANCELED = 'canceled',
  COMPLETED = 'completed',
  ABORTED = 'aborted',
}
